<script lang="ts" setup>
import type { Benefits } from '~~/server/api/homepage'

export interface WidgetBenefitsProps {
    data: Benefits
}

const props = defineProps<WidgetBenefitsProps>()

const headingId = useId()
</script>
<template>
  <section
    class="bg-white rounded py-10 px-2 px-md-6 box-shadow-1"
    data-cy="widget_benefits"
  >
    <header class="text-center">
      <Tag
        size="small"
        background-color="gray-1"
        text-color="primary"
        class="text-uppercase mx-auto mb-3"
      >
        {{ props.data.tag }}
      </Tag>
      <Heading
        :id="headingId"
        level="h2"
        class="beta mb-8"
      >
        {{ props.data.title }}
      </Heading>
    </header>
    <ul
      v-if="props.data.data"
      class="row g-2 g-md-6"
    >
      <li
        v-for="(benefit, index) in props.data.data"
        :key="`wbi-${index}`"
        class="col-12 col-md-6"
        role="listitem"
        :aria-labelledby="headingId"
      >
        <article
          class="px-4 py-8 rounded bg-gray-3 h-100 d-flex d-md-block align-items-center"
        >
          <img
            :src="benefit.icon?.path"
            loading="lazy"
            decoding="async"
            width="48"
            height="48"
            alt=""
            class="d-block ms-md-auto mb-md-4 me-3 me-md-auto flex-shrink-0"
          >
          <Typo>
            <p class="text-black mb-0 fw-bolder text-md-center">
              {{ benefit.description }}
            </p>
          </Typo>
        </article>
      </li>
    </ul>
  </section>
</template>
